import { Spin } from "antd";
import { useAFLRequests } from "../../../../procedure/human-organization/absence-letter/hooks";
import { ApprovalStatus, Table } from "../../../../../components";
import { useColumn } from "../../Employees/hooks/use-column";
import { DateHelper, StringHelper } from "../../../../../helper";
import { DateFormat } from "../../../../../constants";
import AFLStepsForm from "./afl-steps-form";

const ConfigAFLRequests = () => {
  const { data, isLoading } = useAFLRequests();
  const { getColumnSearchProps } = useColumn();

  if (isLoading) return <Spin />;

  const columns = [
    {
      title: "Số phiếu",
      key: "id",
      dataIndex: "id",
      align: "center" as const,
      ...getColumnSearchProps("id", "Vui lòng nhập số phiếu"),
    },
    {
      title: "Ngày tạo",
      key: "Created",
      dataIndex: "Created",
      render: (date: string) => DateHelper.formatDateToString(date, { format: DateFormat.DD_MM_YYYY }),
      ...getColumnSearchProps("Created", "Vui lòng nhập người tạo"),
    },
    {
      title: "Tên người tạo",
      key: "eCreatedBy",
      dataIndex: "eCreatedBy",
      render: (creator: string) => StringHelper.verticalBarSplit(creator)[1],
      ...getColumnSearchProps("eCreatedBy", "Vui lòng nhập người tạo"),
    },
    {
      title: "Tên người nghỉ",
      key: "eRequestName",
      dataIndex: "eRequestName",
      ...getColumnSearchProps("eRequestName", "Vui lòng nhập người tạo"),
    },
    {
      title: "Tiêu đề",
      key: "Title",
      dataIndex: "Title",
      ...getColumnSearchProps("Title", "Vui lòng nhập người tạo"),
    },
    {
      title: "Tình trạng",
      key: "eRequestStatus",
      dataIndex: "eRequestStatus",
      render: (text: string) => <ApprovalStatus status={text} />,
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey={"id"}
      expandable={{
        expandedRowRender: (record) => <AFLStepsForm record={record} />,
      }}
    />
  );
};

export default ConfigAFLRequests;
